/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';
import { interviewAdhocAttendeeDtoSchema } from './interview-adhoc-attendee-dto';
import { interviewContactDtoSchema } from './interview-contact-dto';

export const calendarManualInterviewRequestDtoSchema = z.object({ "adhocAttendee": z.lazy(() => interviewAdhocAttendeeDtoSchema).nullish(), "availabilityNote": z.string().nullish(), "contact": z.lazy(() => interviewContactDtoSchema).nullish(), "createdAt": z.string().datetime(), "id": z.string().uuid() });
export type CalendarManualInterviewRequestDto = z.infer<typeof calendarManualInterviewRequestDtoSchema>;
